import moment from "moment"
import Vue from 'vue'

Vue.mixin({
    methods: {
        generateAspNetJsonString(a) {
            var b = "{";
            for (var c in a)
                if ("object" != typeof a[c])
                    b += '"' + c + '":"' + escape(a[c]) + '",';
            return b.substr(0, b.length - 1) + "}"
        },
        isObjectEmpty(someObject) {
            return (Object.keys(someObject).length === 0)
        },
        isUndefined(someObject) {
            return (typeof someObject === "undefined")
        },
        isInteger(num) {
            if (isNaN(num)) return false
            let x = parseFloat(num)
            return (x | 0) === x
        },
        isFloat(num) {
            return num !== "" && !isNaN(num) && Math.round(num) !== num;
        },
        getFormatDate(dt, dtFormat) {
            return moment(String(dt)).format(dtFormat)
        },
        checkFilesSize(files) {
            let size = 0
            for (let i = 0; i < files.length; i++) {
                size += files[i].size
            }
            return (size <= this.$store.getters.getMaxFileSize)
        },
        checkFilesExt(files) {
            let res = true
            for (let i = 0; i < files.length; i++) {
                let fName = files[i].name
                if (!this.$store.getters.getFileExtensions.includes(fName.split('.').pop().toLowerCase())) res = false
            }
            return res
        },
        getResultByAccessMask(accessMask, type) {
            //type:
            // 0 бит - general, т.е. общий доступ
            // 1 бит - show menu
            // 2 бит - new record
            // 3 - edit record
            // 4 - archive, доступ на просмотр архивов по данному объекту, и все сопутствующие действия
            // 5 - delete, доступ на пометку на удаление
            // 6 - status, доступ на смену статуса записи (к примеру, блокировка записи, и т.д.
            // 7 - print
            // 8 - export
            const mask = [0b000000001, 0b000000010, 0b000000100, 0b000001000, 0b000010000, 0b000100000, 0b001000000, 0b010000000, 0b100000000]
            //              1       2           4           8       16          32       64         128         256
            return (accessMask & mask[type]) ? true : false
        },
        getUserActionAccessArray(pageName, accessObjects) {
            let userAccess = {
                "show": false,
                "new": false,
                "edit": false,
                "archive": false,
                "delete": false,
                "status": false
            }

            let item = accessObjects.filter(function (el) {
                return el.AccessObject.toLowerCase() === pageName.toLowerCase()
            })

            if (item && item.length > 0 && item[0].AccessMask) {
                userAccess["show"] = this.getResultByAccessMask(item[0].AccessMask, 1)
                userAccess["new"] = this.getResultByAccessMask(item[0].AccessMask, 2)
                userAccess["edit"] = this.getResultByAccessMask(item[0].AccessMask, 3)
                userAccess["archive"] = this.getResultByAccessMask(item[0].AccessMask, 4)
                userAccess["delete"] = this.getResultByAccessMask(item[0].AccessMask, 5)
                userAccess["status"] = this.getResultByAccessMask(item[0].AccessMask, 6)

            }

            return userAccess
        },
        getUserDataAccess(pageName, accessObjects) {
            let item = accessObjects.filter(function (el) {
                return el.AccessObject.toLowerCase() === pageName.toLowerCase()
            })

            return (item && item.length > 0 && item[0].AccessMask && this.getResultByAccessMask(item[0].AccessMask, 0))
        },
        newGuid() {
            return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            )
        },
    }
})

